export const ONE_TIME = 'one_time';
export const STATEMENT_DUE_DATE = 'statement_due_date';
